import { render, staticRenderFns } from "./academic_course_management.vue?vue&type=template&id=0796951a&scoped=true&"
import script from "./academic_course_management.vue?vue&type=script&lang=js&"
export * from "./academic_course_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_course_management.vue?vue&type=style&index=0&id=0796951a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796951a",
  null
  
)

export default component.exports